// Sound design — optional audio cues for key moments
// All sounds are generated programmatically using Web Audio API (no files needed)

const ctx = typeof window !== 'undefined' && window.AudioContext ? new (window.AudioContext || window.webkitAudioContext)() : null;

function getEnabled() {
  try { return localStorage.getItem('ug_sounds') === 'true'; } catch { return false; }
}

export function setSoundsEnabled(v) {
  try { localStorage.setItem('ug_sounds', String(v)); } catch {}
}

export function isSoundsEnabled() { return getEnabled(); }

function playTone(freq, duration, type = 'sine', volume = 0.08) {
  if (!ctx || !getEnabled()) return;
  try {
    if (ctx.state === 'suspended') ctx.resume();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, ctx.currentTime);
    gain.gain.setValueAtTime(volume, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + duration);
  } catch {}
}

// Upload complete — satisfying ding
export function soundUploadComplete() {
  playTone(880, 0.15, 'sine', 0.06);
  setTimeout(() => playTone(1320, 0.2, 'sine', 0.05), 100);
}

// New message received — gentle chime
export function soundNewMessage() {
  playTone(660, 0.1, 'triangle', 0.04);
  setTimeout(() => playTone(880, 0.15, 'triangle', 0.03), 80);
}

// Approval / success — triumphant chord
export function soundSuccess() {
  playTone(523, 0.2, 'sine', 0.05);
  setTimeout(() => playTone(659, 0.2, 'sine', 0.04), 100);
  setTimeout(() => playTone(784, 0.3, 'sine', 0.04), 200);
}

// Error / warning — low thud
export function soundError() {
  playTone(220, 0.15, 'square', 0.03);
}

// Click — subtle tap
export function soundClick() {
  playTone(1000, 0.04, 'sine', 0.02);
}
